/**
 * angular-strap
 * @version v2.3.12 - 2017-01-26
 * @link http://mgcrea.github.io/angular-strap
 * @author Olivier Louvignes <olivier@mg-crea.com> (https://github.com/mgcrea)
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
'use strict';angular.module('mgcrea.ngStrap.helpers.debounce',[]).factory('debounce',['$timeout',function(n){return function(t,u,r){var e=null;return function(){var l=this,a=arguments,c=r&&!e;return e&&n.cancel(e),e=n(function(){e=null,r||t.apply(l,a)},u,!1),c&&t.apply(l,a),e}}}]).factory('throttle',['$timeout',function(n){return function(t,u,r){var e=null;return r||(r={}),function(){var l=this,a=arguments;e||(r.leading!==!1&&t.apply(l,a),e=n(function(){e=null,r.trailing!==!1&&t.apply(l,a)},u,!1))}}}]);

